'use client';
import { useEffect } from 'react';
import { readFontExperimentFromBrowser } from '@/config/fontExperiment';

const LOCAL_FONTS = {
  roboto: { family: 'Roboto', href: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap' },
  manrope: { family: 'Manrope', href: 'https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&display=swap' },
  jakarta: { family: 'Plus Jakarta Sans', href: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap' },
  nunito: { family: 'Nunito', href: 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap' },
  poppins: { family: 'Poppins', href: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap' },
  sora: { family: 'Sora', href: 'https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&display=swap' },
  outfit: { family: 'Outfit', href: 'https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap' },
};

function isLocalhost() {
  return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
}

// This component only renders in development and makes remote font requests
// only when the page itself is running on localhost. Production ships Inter
// alone, so font experiments can never affect real visitors or PageSpeed.
export default function FontExperiment() {
  useEffect(() => {
    if (!isLocalhost()) return;
    const id = readFontExperimentFromBrowser();
    if (id === 'inter') {
      document.documentElement.style.setProperty('--font-v1', 'var(--font-inter)');
      return;
    }
    const font = LOCAL_FONTS[id];
    if (!font) return;
    const linkId = 'adcast-local-font-experiment';
    let link = document.getElementById(linkId);
    if (!link) {
      link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    link.href = font.href;
    document.documentElement.style.setProperty('--font-v1', `'${font.family}', sans-serif`);
  }, []);

  return null;
}
